import { http } from './http'
import { Pagination, PaginationParams } from './map'
import { Info } from '../../common/models'
import { InfoPayload, Parent } from '../../common/models/info'

export const getAllInfos = (params?: PaginationParams) =>
  http.get<Pagination<Info>>('/operations/infos', {
    params,
  })

export const getAllParents = () =>
  http.get<Parent[]>('/operations/infos/parent-list')

export const createInfo = (data: InfoPayload) =>
  http.post<Info>('/operations/infos', data)

export const updateInfo = (id: string, data: InfoPayload) =>
  http.put<Info>(`/operations/infos/${id}`, data)

export const unpublishInfo = (ids: string[]) =>
  http.put<Info[]>('/operations/infos/unpublish', {
    ids,
  })

export const publishInfo = (ids: string[]) =>
  http.put<Info[]>('/operations/infos/publish', {
    ids,
  })

export const deleteInfo = (ids: string[]) =>
  http.delete('/operations/infos', {
    data: {
      ids,
    },
  })

export const getInfo = (id: string) => http.get<Info>(`/operations/infos/${id}`)
